import React, { useEffect, useState } from 'react';
import classes from "./CategoryCards.module.css";
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import { FaChevronLeft } from "react-icons/fa6";


const CategoryCards = ({ data, active, categoryChangeHandler }) => {

    console.log(active,'d');

    const [leftConstraint, setLeftConstraint] = useState(0);

    useEffect(() => {
        const updateConstraints = () => {
            // logic to implement the drag to upto how much screen
            // padding from screen sides + total cards * width of card + total cards * gap between cards + total cards * box shadow twice

            if (window.innerWidth <= 800) {
                setLeftConstraint(
                    10 +
                    (data?.length + 2) * 100 +
                    (data?.length + 2) * 10 +
                    (data?.length + 2) * 1 -
                    window.innerWidth
                );
            } else {
                setLeftConstraint(
                    window.innerWidth * 0.05 +
                    (data?.length + 2) * 100 +
                    (data?.length + 2) * 10 +
                    (data?.length + 2) * 1 -
                    window.innerWidth
                );
            }
        };

        updateConstraints();
        window.addEventListener("resize", updateConstraints);

        return () => {
            window.removeEventListener("resize", updateConstraints);
        };
    }, [data]);

    const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = (event) => {
        setStartPosition({ x: event.clientX, y: event.clientY });
        setIsDragging(false);
    };

    const handleMouseUp = (
        event,
        data
    ) => {
        const distance = Math.sqrt(
            Math.pow(event.clientX - startPosition.x, 2) +
            Math.pow(event.clientY - startPosition.y, 2)
        );
        if (distance < 5 && !isDragging) {
            categoryChangeHandler(data);
        }
    };

    const handleMouseMove = () => {
        setIsDragging(true);
    };

    const navigate = useNavigate();

    return (
        <div className={classes.navbar_genres}>

            <motion.div
                drag={"x"}
                dragConstraints={{
                    top: 0,
                    left: -leftConstraint,
                    right: 0,
                    bottom: 0,
                }}
                transition={{
                    type: "spring",
                    damping: 100,
                    stiffness: 100,
                }}
                className={classes.genre_grid}
                style={{
                    gridTemplateColumns: `repeat(${data?.length + 2
                        },100px)`,
                }}
            >

                <button type="button" className={classes.view}
                    onClick={() => navigate(`/`)}
                >
                    {/* <FaChevronLeft className={classes.icon} /> */}
                    <i className={`pi pi-chevron-left ${classes.icon}`} />
                </button>
                <button
                    type="button"
                    className={`${classes.genre} 
            ${active === null
                            ? classes.genre_active
                            : null
                        }`}
                    // onClick={() => genreClickHandler({ name: "all", id: null })}
                    onMouseDown={(event) => handleMouseDown(event)}
                    onMouseUp={(event) =>
                        handleMouseUp(event, null)
                    }
                    onMouseMove={handleMouseMove}
                >
                    All
                </button>
                {data?.map((dataItem, idx) => (
                    <button
                        type="button"
                        className={`${classes.genre} 
                                ${active == dataItem?.sub_category_id ? classes.genre_active : null}
                            }`}
                        key={idx}
                        // onClick={() => genreClickHandler(genre)}
                        onMouseDown={(event) => handleMouseDown(event)}
                        onMouseUp={(event) =>
                            handleMouseUp(event, dataItem?.sub_category_id)
                        }
                        onMouseMove={handleMouseMove}
                    >
                        {dataItem?.sub_category_name}
                    </button>
                ))}
            </motion.div>

        </div>

    )
}

export default CategoryCards